import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.dev';
import { BehaviorSubject, catchError, map, Observable, of, shareReplay, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private apiURL = environment.apiURL;
  private userRoleSubject = new BehaviorSubject<string | null>(null);
  userRole$ = this.userRoleSubject.asObservable();
  private userRole: string | null = null; 

  constructor(private http: HttpClient) { }

  // Registro de usuario
  register(user: any): Observable<any> {
    return this.http.post(`${this.apiURL}/auth/signup`, user, { withCredentials: true });
  }

  // Login de usuario
  login(credentials: any): Observable<any> {
    return this.http.post(`${this.apiURL}/auth/login`, credentials, { withCredentials: true }).pipe(
      tap(() => this.fetchUserRole()) // Llama a la función que obtiene el rol después de iniciar sesión
    );
  }


  // Cerrar sesión (eliminar cookie de sesión)
  logout(): Observable<any> {
    return this.http.post(`${this.apiURL}/auth/logout`, {}, { withCredentials: true }).pipe(
      tap(() => this.userRoleSubject.next(null))
    );
  }

  //obtiene el id 
  info(): Observable<{ id: number; username: string }> {
    return this.http.post<{ id: number; username: string }>(`${this.apiURL}/auth/info`, {}, { withCredentials: true }).pipe(
      tap((response) => {
        // Aquí puedes guardar el ID en una propiedad de la clase
        console.log('ID recibido:', response.id);
        this.userRoleSubject.next(response.username); // Opcional: actualiza el BehaviorSubject si es necesario
      }),
      catchError((error) => {
        console.error('Error al obtener la información del usuario:', error);
        return of({ id: 0, username: '' }); // Devuelve un valor por defecto en caso de error
      })
    );
  }

  fetchUserRole(): Observable<string | null> {
    // Si el rol ya está en memoria, lo devolvemos sin hacer una petición extra
    if (this.userRole !== null) {
      return of(this.userRole);
    }
  
    // Si no está en memoria, hacemos la petición a la API
    return this.http.get<{ role: string }>(`${this.apiURL}/auth/me`, { withCredentials: true }).pipe(
      tap(response => {
        this.userRole = response.role; // Guardamos en caché
        this.userRoleSubject.next(response.role);
      }),
      map(response => response.role),
      catchError(() => {
        this.userRole = null; // En caso de error, almacenamos null
        this.userRoleSubject.next(null);
        return of(null);
      }),
      shareReplay(1) // Evita múltiples peticiones concurrentes
    );
  }
  
  // Método para limpiar la caché al cerrar sesión
  clearUserRole(): void {
    this.userRole = null;
    this.userRoleSubject.next(null);
  }
}